<template>
  <v-data-table
    class="transparent"
    :headers="headers"
    :items="referencias"
  >
    <template #[`item.estatus`]="{ item }">
      <v-chip
        label
        :color="getDocumentStatusColor(item.estatus_c3)"
        class="font-weight-bold"
      >
        {{ getDocumentStatusLabel(item.estatus_c3) }}
      </v-chip>
    </template>
    <template #[`item.acciones`]="{ item }">
      <v-btn
        color="green"
        icon
        @click="updateReferenciaStatus(item, true)"
      >
        <v-icon dark>
          mdi-check
        </v-icon>
      </v-btn>
      <v-btn
        color="red"
        icon
        @click="updateReferenciaStatus(item, false)"
      >
        <v-icon dark>
          mdi-cancel
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import createPersonaApiRepository from '../../modules/persona/infrastructure/PersonaApiRepository';

export default {
  props: {
    referencias: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          value: 'nombre',
        },
        {
          text: 'Segundo nombre',
          align: 'start',
          value: 'segundo_nombre',
        },
        {
          text: 'Apellido paterno',
          align: 'start',
          value: 'apaterno',
        },
        {
          text: 'Apellido materno',
          align: 'start',
          value: 'amaterno',
        },
        {
          text: 'Última actualización',
          align: 'start',
          value: 'edited_at',
        },
        {
          text: 'Estatus',
          align: 'start',
          value: 'estatus',
        },
        {
          text: '¿Aprobar registro?',
          align: 'center',
          value: 'acciones',
          sortable: false,
        },
      ],
    };
  },

  methods: {
    getDocumentStatusLabel(statusId) {
      if (statusId || statusId === false) {
        return statusId ? 'Aprobado' : 'Rechazado';
      }

      return 'Pendiente de revisión';
    },

    getDocumentStatusColor(statusId) {
      if (statusId || statusId === false) {
        return statusId ? 'success' : 'red';
      }

      return 'grey';
    },

    async updateReferenciaStatus(referencia, status) {
      const repository = createPersonaApiRepository();
      const payload = {
        ...referencia,
        estatus_c3: status,
      };
      await repository.updateReferencia(payload);
      const referenciaIndex = this.referencias.findIndex((item) => item.id === referencia.id);
      this.referencias[referenciaIndex].estatus_c3 = status;
    },
  },
};
</script>
